import React, { useMemo } from "react";
import { titleWithoutUnderscore } from "../../helpers/utility";

export const ChangeRequestMessage = ({msg, isLoggedInUser}) => {

  
    return (
        <div className={`rounded-md ${isLoggedInUser() ? 'bg-blue-100': 'bg-white border'}  p-2 shadow`}>
            <div className={`text-gray-800 text-start`}>
                <h1 className={`flex gap-2 justify-between capitalize font-bold border-b }  py-1 px-2 rounded-t-md`}>
                    {titleWithoutUnderscore(msg.message?.event_type)}
                </h1>
                <div className={`p-2 rounded-b-md`}>
                    <p>{msg.message.data?.text}</p>
                </div>
            </div>
        </div>
    );
};